import Modal from "react-modal";
import { colors } from "../../data/colors";
import { documentModalStyles } from "../../data/styles/modalStyles";
import Header from "../componentModal/Header";
import useDocumentModal from "./useDocumentModal";
import MenuList from "../componentModal/MenuList";
import DocSection from "../componentModal/DocSection";
import {
  docInterventionData,
  docPersonData,
  purchasesCodes,
} from "../../data/main";
import TotalsBox from "./components/TotalsBox";
import ItemsTable from "./components/ItemsTable";
import { stdObject } from "../../data/types/stdObject";
import RecordIssuesCard from "./components/RecordIssuesCard";
import { DocContext } from "../../context/MainContext";
import convertDate from "../../utils/convertDate";
import FilesManager from "./components/FilesManager";
import { getCurrentDate } from "../../utils/getCurrentDate";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

export default function DocumentModal({
  open = false,
  info,
  close = () => {},
}: {
  open: boolean;
  info: stdObject;
  close: () => void;
}) {
  const {
    t,
    squareButtons,
    tabIndex,
    switchTab,
    secondBox,
    staffListFiltered,
    scrollRef,
    type,
    data,
    minModalWidth,
    mainColor,
    personItemFiltered,
    onChange,
    issues,
    items,
    totalsData,
    title,
    buttons,
    tabs,
    openRecords,
    sndBoxbuttons,
    records,
    recordsRef,
    docActive,
    fileInputRef,
    startUploading,
    handleButtonClick,
    filesList,
    switchFileGroup,
    filesButtons,
    handleFile,
    refreshFiles,
    headerInfo,
    minSizeDoc,
    staffList,
    recordFields,
    changeRecActive,
  } = useDocumentModal({
    open,
    info,
    close,
  });

  const user: any = useSelector((state: RootState) => state.data.user);
  const userAccess: stdObject = useSelector(
    (state: RootState) => state.data.userAccess,
  );
  const screens = () => {
    switch (tabIndex) {
      case 1:
        return (
          <FilesManager
            filesButtons={filesButtons}
            switchFileGroup={switchFileGroup}
            filesList={filesList}
            mainColor={mainColor}
            handleButtonClick={handleButtonClick}
            handleFile={handleFile}
            refreshFiles={refreshFiles}
          />
        );
      case 2:
        return <div style={{ backgroundColor: "blue", flex: 1 }}>a</div>;
      default:
        return (
          <>
            <div className="docMainContent">
              <div ref={scrollRef} className="docInfoContent">
                {type && data && (
                  <>
                    {/*<DocSection
                      mainWidth={minModalWidth}
                      mainColor={mainColor}
                      data={[...docIntData.map((e) => data[`${e}${type}`])]}
                    />*/}
                    {type !== "SAL" && (
                      <div style={{ position: "relative" }}>
                        <DocSection
                          title={
                            type === "TRA"
                              ? t("c.SUC")
                              : purchasesCodes.includes(type)
                                ? t("p.supplier")
                                : t("p.customer")
                          }
                          globalActive={docActive.person}
                          type={type}
                          mainWidth={minModalWidth}
                          mainColor={mainColor}
                          openRecords={openRecords}
                          onChange={onChange}
                          personCode={
                            info.typeText === "purchases" ? "PRO" : "CLI"
                          }
                          data={[
                            ...docPersonData.map((e) => data[`${e}${type}`]),
                            ...personItemFiltered,
                          ]}
                        />
                      </div>
                    )}
                    {staffListFiltered.length > 0 && (
                      <DocSection
                        title={t("p.staff")}
                        globalActive={docActive.staff}
                        mainWidth={minModalWidth}
                        mainColor={mainColor}
                        data={staffListFiltered}
                      />
                    )}
                    {type === "SEV" && (
                      <>
                        <DocSection
                          title={t("p.intervention")}
                          globalActive={docActive.interv}
                          mainWidth={minModalWidth}
                          mainColor={mainColor}
                          data={docInterventionData
                            .filter((e) => e !== "PIM")
                            .map((e) => data[`${e}${type}`])}
                          tax={data.PIMSEV}
                          onChange={onChange}
                        />
                        {type === "SEV" &&
                          issues.length > 0 &&
                          ![0, 4].includes(user.TEC) && (
                            <DocSection
                              title={t("p.issues")}
                              globalActive={docActive.issues}
                              mainWidth={minModalWidth}
                              issues={true}
                              data={issues}
                              minSizeDoc={minSizeDoc}
                              initOwner={info.prev[`AGE${type}`]}
                            />
                          )}
                      </>
                    )}
                    {(type !== "SEV" ||
                      (type === "SEV" && ![3, 5].includes(user.TEC))) && (
                      <ItemsTable
                        type={type}
                        items={items}
                        minModalWidth={minModalWidth}
                        mainColor={mainColor}
                      />
                    )}
                  </>
                )}
              </div>
              {!!userAccess.C.C1R && (
                <div
                  className="docExtraContent"
                  style={{
                    width: secondBox ? (minModalWidth ? "100%" : 500) : 0,
                  }}
                >
                  <MenuList
                    mainColor={mainColor}
                    buttons={sndBoxbuttons}
                    style={{ backgroundColor: colors.lightGrey2 }}
                    docActive={docActive}
                  />
                  <div
                    ref={recordsRef}
                    className="docInfoContent"
                    style={{
                      backgroundColor: colors.white,
                      justifyItems: "center",
                    }}
                  >
                    {headerInfo
                      .filter(
                        (e: stdObject) =>
                          !e.code || (e.code && recordFields[e.code]),
                      )
                      .map((e: stdObject, index: number) => (
                        <div key={index} style={e.style}>
                          {e.label ? `${e.label}: ` : ""}
                          {e.name === "printDate"
                            ? convertDate({
                                info: getCurrentDate(true),
                                t,
                              })
                            : e.name}
                        </div>
                      ))}
                    {records ? (
                      records
                        .filter((e: stdObject) => {
                          return (
                            (headerInfo.length > 0 && e.active) ||
                            !headerInfo.length
                          );
                        })
                        .map((e: stdObject, index: number) => (
                          <RecordIssuesCard
                            key={index}
                            data={e}
                            index={index}
                          />
                        ))
                    ) : (
                      <div className="spinner" />
                    )}
                  </div>
                </div>
              )}
            </div>
            <TotalsBox
              type={type}
              totalsData={totalsData}
              data={data}
              itemsQuantity={items.length}
              workshop={data[`TAL${type}`]}
              shipping={data[`ENV${type}`]}
              notes={data[`NOT${type}`]}
              onChange={onChange}
            />
          </>
        );
    }
  };

  return (
    <DocContext.Provider
      value={{
        info,
        docActive,
        staffList,
        recordFields,
        changeRecActive,
        headerInfo,
      }}
    >
      <Modal
        isOpen={open}
        onRequestClose={() => {}}
        style={{
          ...documentModalStyles,
          content: {
            ...documentModalStyles.content,
            width: minSizeDoc ? 500 : "90%",
          },
        }}
      >
        <div className="documentContainer">
          <Header
            title={title}
            mainColor={mainColor}
            squareButtons={squareButtons}
            date={
              `FEC${type}` in data
                ? convertDate({ info: data[`FEC${type}`].value, t })
                : ""
            }
          />
          {!!buttons.filter((e) => e).length && (
            <MenuList
              tabs={tabs}
              mainColor={mainColor}
              switchTab={switchTab}
              tabIndex={tabIndex}
              buttons={buttons}
              docActive={docActive}
            />
          )}
          {screens()}
          <input
            type="file"
            ref={fileInputRef}
            onChange={startUploading}
            style={{ display: "none" }}
          />
        </div>
      </Modal>
    </DocContext.Provider>
  );
}
